import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { LucideIcon } from 'lucide-react';

interface NavLinkProps {
  to?: string;
  onClick?: () => void;
  icon: LucideIcon;
  label: string;
  isExpanded: boolean;
}

export const NavLink: React.FC<NavLinkProps> = ({ to, onClick, icon: Icon, label, isExpanded }) => {
  const location = useLocation();
  const isActive = to && location.pathname === to;

  const handleClick = () => {
    if (onClick) {
      onClick();
    }
  };

  const baseClassName = `flex items-center text-sm font-medium relative group hover:bg-[#0044CC] text-white/90 h-10 w-full ${
    isActive ? 'bg-[#0044CC]' : ''
  }`;
  const iconContainerClass = isExpanded ? 'w-16 flex justify-center flex-shrink-0' : 'w-full flex justify-center';

  const content = (
    <>
      <div className={iconContainerClass}>
        <Icon className="w-5 h-5" />
      </div>
      {isExpanded && (
        <span>{label}</span>
      )}
      {!isExpanded && (
        <div className="absolute left-full min-w-max bg-[#0044CC] text-white text-sm invisible opacity-0 group-hover:visible group-hover:opacity-100 h-10 flex items-center px-3 ml-1">
          {label}
        </div>
      )}
    </>
  );

  if (to) {
    return (
      <Link to={to} onClick={handleClick} className={baseClassName}>
        {content}
      </Link>
    );
  } else if (onClick) {
    return (
      <button onClick={handleClick} className={baseClassName}>
        {content}
      </button>
    );
  } else {
    return (
      <div className={baseClassName}>{content}</div>
    );
  }
};